<template>
	<div class="div-content">
		<div class="btn-add"><el-button size="mini" @click="add">新增</el-button></div>
		<!-- 表格 -->
		<el-table :data="tableData" max-height="600" border height="480" style="width: 100%"
				  :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ 'text-align': 'center' }">
			<el-table-column type="index" label="编号" width="60px" />
			<el-table-column prop="equipmentName" min-width="150px" label="设备名称">
				<template #default="scope">
					<el-input v-model="scope.row.equipmentName" :disabled="scope.row.btnText"
							  placeholder="请输入内容"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="equipmentAnotherName" min-width="150px" label="设备别名">
				<template #default="scope">
					<el-input v-model="scope.row.equipmentAnotherName" :disabled="scope.row.btnText"
							  placeholder="请输入内容"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="equipmentCode" label="设备编码" min-width="150px">
				<template #default="scope">
					<el-input v-model="scope.row.equipmentCode" :disabled="scope.row.btnText" placeholder="请输入"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="sim" label="SIM卡号" min-width="150px">
				<template #default="scope">
					<el-input v-model="scope.row.sim" :disabled="scope.row.btnText" placeholder="请输入"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="dtuId" label="dtuId">
				<template #default="scope">
					<el-input v-model="scope.row.dtuId" :disabled="scope.row.btnText" placeholder="请输入"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="channelCount" label="通道总数">
				<template #default="scope">
					<el-input v-model="scope.row.channelCount" :disabled="scope.row.btnText" placeholder="请输入"></el-input>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="modelId" label="设备模块号">
				<template #default="scope">
					<el-input v-model="scope.row.modelId" :disabled="scope.row.btnText" placeholder="请输入"></el-input>
				</template>
			</el-table-column> -->
			<el-table-column prop="sim" label="预警值" min-width="250px">
				<template #default="scope">
					<div class="warning-value">
						<el-input v-model="scope.row.beginWarningValue" :disabled="scope.row.btnText"
								  placeholder="请输入"></el-input>
						<div class="input-line"></div>
						<el-input v-model="scope.row.endWarningValue" :disabled="scope.row.btnText"
								  placeholder="请输入"></el-input>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="equipmentTypeUuid" label="设备类型" min-width="120px">
				<template #default="scope">
					<el-select filterable v-model="scope.row.equipmentTypeUuid" v-if="!scope.row.btnText" placeholder="请选择"
							   @change="quipmentTypeChange($event, scope.row, scope.$index)">
						<el-option v-for="item in options" :key="item.equipmentTypeId" :label="item.equipmentTypeName"
								   :value="item.equipmentTypeUuid"></el-option>
					</el-select>
					<el-input v-model="scope.row.equipmentTypeName" v-else disabled></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="communicationChannel" label="通讯通道" min-width="100px">
				<template #default="scope">
					<el-input v-model="scope.row.communicationChannel" :disabled="scope.row.btnText"
							  placeholder="请输入"></el-input>
				</template>
			</el-table-column>
			<el-table-column prop="isEnable" label="是否启用" min-width="100px">
				<template #default="scope">
					<el-switch v-model="scope.row.isEnable" :disabled="scope.row.btnText"></el-switch>
				</template>
			</el-table-column>
			<el-table-column prop="status" label="状态" width="80px">
				<template #default="scope">
					<div :class="scope.row.status == 0 ? '' : scope.row.status == 1 ? 'isStatus' : 'isRed'"
						 class="default-status">
						<div :class="scope.row.status == 0 ? '' : scope.row.status == 1 ? 'isCircle' : 'isRedle'"
							 class="circle-div"></div>
						<div>{{ scope.row.status == 0 ? '离线' : scope.row.status == 1 ? '在线' : '未检测到状态' }}</div>
					</div>
				</template>
			</el-table-column>
			<!-- 操作 -->
			<el-table-column label="操作" width="80px" fixed="right">
				<template #default="scope">
					<div>
						<!-- <div id="">
							
						</div> -->
						<el-button type="text" v-if="!scope.row.equipmentId" @click="sheBeiPeiZhiBC()">{{ scope.row.btnText
							? '编辑' : '保存' }}</el-button>
						<el-button type="text" v-if="scope.row.equipmentId" @click="bianJi(scope.row)">{{ scope.row.btnText
							? '编辑' : '保存' }}</el-button>
						<el-button type="text" style="color: red;" v-if="scope.row.equipmentId"
								   @click="shanChu(scope.$index, tableData)">删除</el-button>
					</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>
<script>
export default {
	name: 'shebeipeizhi',
	props: [],
	data() {
		return {
			btnText: true,
			options: [],
			tableData: [
				{
					bridgeUuid: '',
					equipmentName: '',
					equipmentCode: '',
					sim: '',
					dtuId: '',
					channelCount: '',
					// modelId: '',
					beginWarningValue: '',
					endWarningValue: '',
					equipmentTypeName: '',
					equipmentTypeUuid: '',
					communicationChannel: '',
					isEnable: false,
					status: 1,
					equipmentAnotherName: ''
				}
			],
			// 分页器
			pagination: {
				total: 0,
				per_page: 10,
				from: 1,
				to: 0,
				current_page: 1 //当前页数
			}
		}
	},
	computed: {},
	async mounted() {
		// 获取设备类型信息
		this.getBiEquipmentType()
	},
	methods: {
		// 判断是否是修改操作
		isUpdate() {
			return global.isUpdate ? true : false
		},
		// 设备类型选择
		quipmentTypeChange(e, row, index) {
			this.options.map(item => {
				if (item.equipmentTypeUuid === e) {
					row.equipmentTypeUuid = item.equipmentTypeUuid
					row.equipmentTypeName = item.equipmentTypeName
				}
			})
			console.log(e)
			console.log(row)
			console.log(index)
		},
		// 保存
		async sheBeiPeiZhiBC() {
			console.log(global.bridgeUuid)
			let newArry = []
			const data = JSON.parse(JSON.stringify(this.tableData))
			data.map((item, index) => {
				item.isEnable = item.isEnable ? 0 : 1
				item.bridgeUuid = global.bridgeUuid
				if (!item.btnText) {
					console.log(item)
					newArry.push(Object.assign({}, data[index]))
				}
			})
			console.log(newArry)
			const res = await this.$api.sendPost('/biBridge/saveEquipment', newArry)
			if (res.errcode == 0) {
				this.$message.success(res.errmsg)
				this.$emit('updateIndex', '3')
			} else {
				this.$message.error(res.errmsg)
			}
		},
		// 编辑
		async bianJi(row) {
			// true编辑 false保存
			row.btnText = !row.btnText
			let isBc = row.btnText ? '编辑' : '保存'
			console.log(isBc)
			let data = JSON.parse(JSON.stringify(row))
			console.log(row)
			if (data.btnText) {
				data.isEnable = data.isEnable ? 0 : 1
				const res = await this.$api.sendPost('/biBridge/updateEquipment', data)
				if (res.errcode == 0) {
					row.btnText = true
					this.$message.success(res.errmsg)
				} else {
					row.btnText = false
					this.$message.error(res.errmsg)
				}
			}
			// 保存调用接口
			// if (isBc === '保存') {
			// 	data.isEnable = data.isEnable ? 0 : 1;
			// 	console.log(data);
			// 	const res = await this.$api.sendPost('/biBridge/updateEquipment', data);
			// 	if (res.errcode == 0) {
			// 		row.btnText = true;
			// 		this.$message.success(res.errmsg);
			// 	} else {
			// 		row.btnText = false;
			// 		this.$message.error(res.errmsg);
			// 	}
			// }
		},
		// 删除
		shanChu(index, rows) {
			console.log(rows)
			this.$confirm('是否确认删除?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					// 如果有设备类型uuid则调接口删除数据
					if (rows[index].equipmentUuid) {
						console.log(rows[index])
						const res = await this.$api.sendGet('/biBridge/deteleEquipment', {
							equipmentUuid: rows[index].equipmentUuid
						})
						if (res.errcode == 0) {
							rows.splice(index, 1)
							this.$message.success(res.errmsg)
						} else {
							this.$message.error(res.errmsg)
						}
					} else {
						rows.splice(index, 1)
						this.$message.success('删除成功')
					}
				})
				.catch(() => {
					this.$message.error('已取消操作')
				})
		},
		// 新增表格行
		add() {
			let obj = {
				bridgeUuid: '',
				equipmentName: '',
				equipmentCode: '',
				sim: '',
				dtuId: '',
				channelCount: '',
				// modelId: '',
				beginWarningValue: '',
				endWarningValue: '',
				equipmentTypeName: '',
				equipmentTypeUuid: '',
				communicationChannel: '',
				isEnable: false,
				status: 1,
				equipmentAnotherName: ''
			}
			this.tableData.push(obj)
		},
		// 获取设备类型信息
		async getBiEquipmentType() {
			const res = await this.$api.sendPost('/biEquipmentType/getBiEquipmentType', {
				pageSize: 99999,
				pageNum: 1
			})
			if (res.errcode == 0) {
				this.options = res.data.list
			} else {
				this.options = []
			}
			console.log(res)
			console.log('获取设备类型信息', this.tableData)
		},
		// 分页器----新每页条数
		handleSizeChange(val) {
			this.pagination.per_page = val
			// console.log(val);
			this.click(0)
		},
		// 分页器-----新当前页
		handleCurrentChange(val) {
			this.pagination.current_page = val
			// console.log(val);
			this.click()
		}
	}
}
</script>

<style lang="scss" scoped>
.div-content {
	padding: 0 10px;
	box-sizing: border-box;
	height: 700px;
	overflow: auto;

	.btn-add {
		display: flex;
		padding-bottom: 20px;
	}
}

.default-status {
	color: #666666;
	display: flex;
	align-items: baseline;
	justify-content: center;
}

.circle-div {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background-color: #d8d8d8;
	margin-right: 5px;
}

.isStatus {
	color: #30bb4c;
}

.isCircle {
	background-color: #30bb4c;
}

.isRed {
	color: #ff5722;
}

.isRedle {
	background-color: #ff5722;
}

.warning-value {
	display: flex;
	align-items: center;
}

.input-line {
	margin: 0 10px;
	width: 50px;
	border-bottom: 1px solid #999999;
}
</style>
